module.exports = "/images/bulk-icon.svg?8afb875e62e77e6b9ae4d32d0330f5ea";